import AnalyticCard from '@/components/Analytic/Card'
import AnalyticCardSkeleton from '@/components/skeletons/AnalyticCard'
import DnsIcons from '@/icons/DnsIcons'
import LinkIcons from '@/icons/LinkIcons'
import MonitoringIcons from '@/icons/MonitoringIcons'
import WorldPublicIcons from '@/icons/WorldPublicIcons'
import { getServiceAnalyticUsages } from '@/modules/Service/services'
import { MonitoringQueries, Service } from '@/modules/Service/types'
import { formatBandwidthUnit, formatNumeral } from '@/utils/function'
import React from 'react'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface QuotaProps {
    service: Service
    queries: MonitoringQueries
}
const Quota: React.FC<QuotaProps> = ({ service, queries }) => {
    const { data, renderState } = useQueryWithHandler({
        queryKey: [
            QUERY_KEYS.SERVICES,
            service?.service_creatable_uuid,
            'monitorings',
            'dns_queries',
            queries,
        ],
        loadingComponent: (
            <div className="grid xs:grid-cols-1 md:grid-cols-5 mb-4 gap-4">
                {[1, 2, 3, 4, 5].map((index) => (
                    <AnalyticCardSkeleton key={index} />
                ))}
            </div>
        ),
        queryFn: () =>
            getServiceAnalyticUsages({
                serviceID: service?.service_id,
                params: {
                    gte: queries?.gte,
                    lte: queries?.lte,
                    type: '/usages',
                },
            }),
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div className="grid xs:grid-cols-1 md:grid-cols-5 mb-4 gap-4">
            <AnalyticCard
                title="CDN Requests"
                subtitle="cdn-requests"
                icon={<LinkIcons />}
                replaceSpace="/"
                text={[
                    {
                        prefix: formatNumeral(data?.cdnRequestUsage, 0),
                        suffix: formatNumeral(data?.cdnRequestQuota, 0),
                    },
                ]}
            />
            <AnalyticCard
                title="CDN Traffics"
                subtitle="cdn-traffics"
                icon={<MonitoringIcons />}
                replaceSpace="/"
                text={[
                    {
                        prefix: formatBandwidthUnit(
                            data?.cdnTrafficUsage,
                            0,
                            'Gbps',
                            true
                        ).replace('b', 'B'),
                        suffix: formatBandwidthUnit(
                            data?.cdnTrafficQuota,
                            0,
                            'Tbps',
                            true
                        ).replace('b', 'B'),
                    },
                ]}
            />
            <AnalyticCard
                title="DNS Queries"
                subtitle="dns-queries"
                icon={<DnsIcons />}
                replaceSpace="/"
                text={[
                    {
                        prefix: formatNumeral(data?.dnsQueryUsage, 0),
                        suffix: formatNumeral(data?.dnsQueryQuota, 0),
                    },
                ]}
            />
            <AnalyticCard
                title="Multi CDN Integration"
                subtitle="multi-cdn-integration"
                icon={<WorldPublicIcons />}
                replaceSpace="/"
                text={[
                    {
                        prefix: formatNumeral(data?.mcdnIntegrationUsage, 0),
                        suffix: formatNumeral(data?.mcdnIntegrationQuota, 0),
                    },
                ]}
            />
            <AnalyticCard
                title="Stream"
                subtitle="stream"
                icon={<LinkIcons />}
                replaceSpace="/"
                text={[
                    {
                        prefix: formatNumeral(data?.streamViewUsage, 0),
                        suffix: formatNumeral(data?.streamViewQuota, 0),
                    },
                ]}
            />
        </div>
    )
}

export default Quota
